// export const apiDomain  = 'http://localhost:8000';
export const apiDomain  = 'https://gifts.idcgames.com';

export const getHeader = function(){

    const tokenData = JSON.parse(window.localStorage.getItem('token'))

    const headers = {
        'Accept': 'application/json',
        'Authorization': 'Bearer' + tokenData
    }

    return headers
}